module.exports = __webpack_public_path__ + "5a80831475dc847dd6ad90c4161c4c17.svg";